import { capitalize, Card, Grid } from "@mui/material";
import CardItem from "components/alove/CardItem";
import ItemPageContainer from "layouts/itemPageContainer";
import { Content, ContentStatus, ContentType } from "models/content/Content";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createContentDO, deleteContentDO, getContent, saveContentDO } from "utils/contentUtils";
import { addAlert, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { PageNumber } from "accessNumbers";
import { ContentInfo } from "./components/info";
import { ContentText } from "./components/text";
import { ContentLink } from "./components/link";
import { formatDate } from "utils/globalsUtils";
import { ItemHeader } from "layouts/itemPageContainer/userItem/itemHeader";
import { getSetting, SettingName } from "utils/settingsUtils";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;

export const ContentsView = () => {
  const pageNumber = PageNumber.ViewContent;
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = controller;
  const [content, setContent] = useState({} as Content);
  const { id, type } = useParams();

  useEffect(() => {
    if (id && id !== "new") {
      getContent(id).then((content) => initContentObject(content));
    } else {
      initContentObject(new Content());
    }
  }, [id]);

  const initContentObject = (newContent) => {
    newContent.text ||= "";
    newContent.type ||= parseInt(type!);
    newContent.statusId ||= ContentStatus.draft;
    setContent(Object.assign(new Content(), newContent));
  };

  const _setContent = (newContent) => {
    setContent(Object.assign(new Content(), newContent));
    if (id !== "new") {
      saveContentDO(newContent);
    }
  };

  const createContent = async () => {
    await createContentDO(content).then((content) => navigate(-1));

    addAlert(dispatch, "Content created successfully", false);
  };

  const deleteContent = async () => deleteContentDO(content).then(() => navigate(-1));

  const setImage = (url) => {
    _setContent({ ...content, image: url });
  };

  const copyLink = () => {
    const domain = getSetting(SettingName.WebAppDomain)
    navigator.clipboard.writeText(`${domain}#/content_center?screenId=${content.id}`);
    addAlert(dispatch, "Link copied to clipboard", false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={ContentType[type!]} />
      <ItemPageContainer
        navItems={[
          { label: "Content", ref: "content" },
          { label: "Category", ref: "info" },
          { label: "Text", ref: "text" },
          { label: "Link", ref: "link" },
        ]}
        actions={{
          actionsTitle: "Content actions",
          itemName: `Information content`,
          itemNumber: `#${content.id}`,
          actions: [
            {
              title: "Create",
              onClick: createContent,
              variant: "contained",
              hidden: id !== "new",
            },
            {
              title: "Copy Link",
              onClick: copyLink,
              hidden: content.statusId !== ContentStatus.published,
            }
          ],
        }}
        itemStatus={ id !== "new" && {
          title: "Content status",
          item: content,
          isManager: true,
          changeStatus: async (newStatus) => {
            content.statusId = newStatus;
            _setContent({ ...content });
          },
        }}
        itemHeader={
          <ItemHeader
            image={content.image || ""}
            canChange
            onImageUpload={setImage}
            indications={[
              { title: "Created", value: formatDate(content.created) },
              { title: "Updated", value: formatDate(content.updated) },
              { title: "Type", value: capitalize(ContentType[content.type] || "") },
            ]}
          />
        }
        deleteItem={{
          buttonText: "Delete Content",
          contetnText: "Are you sure you want to delete this content?",
          hidden: !currentRole.hasAccess(pageNumber, PermissionType.Delete),
          onDelete: deleteContent,
        }}
       
      >
        <CardItem title="Content Info" id="info">
          <ContentInfo content={content} setContent={_setContent} />
        </CardItem>
        <CardItem title="Content Link" id="link">
          <ContentLink content={content} setContent={_setContent} />
        </CardItem>
        <CardItem title="Content Text" id="text">
          <ContentText content={content} setContent={(content) => saveContentDO(content)} />
        </CardItem>
      </ItemPageContainer>
    </DashboardLayout>
  );
};
